var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchedImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 592,
    height: 255,
    viewBox: "0 0 592 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(-1262 -306)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "YOU_MATCHED_",
    "data-name": "YOU MATCHED!",
    transform: "translate(1265 461)",
    fill: "#fff",
    fontSize: 73,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YOU MATCHED!")), /*#__PURE__*/React.createElement("text", {
    id: "YOU_MATCHED_2",
    "data-name": "YOU MATCHED!",
    transform: "translate(1265 524)",
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1,
    fontSize: 73,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YOU MATCHED!")), /*#__PURE__*/React.createElement("text", {
    id: "YOU_MATCHED_3",
    "data-name": "YOU MATCHED!",
    transform: "translate(1265 386)",
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1,
    fontSize: 73,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YOU MATCHED!")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedImg);
export default __webpack_public_path__ + "static/media/matchedImg.92cfb443ec799e17f1a9353dd1fc3acb.svg";
export { ForwardRef as ReactComponent };